import type {SlamPointCloudRepository} from '@/domain/interfaces/SlamPointCloudRepository';

export class DeleteSlamPointCloudsUseCase {
  constructor(private readonly repository: SlamPointCloudRepository) {}
  async execute(pointCloudUuid: string) {
    return await this.repository.delete(pointCloudUuid);
  }
}
